/*
 * EarnPointsCta — subtle "Earn 1X TravelBio Points · Earn 3X with a travel
 * advisor →" line rendered under the price/supplier on every traveler-
 * facing booking card.
 *
 * Phase B (2026-08-12).  Traveler + Atlas smart-compare filtered only —
 * DO NOT mount on admin surfaces or Hotelbeds cert-reviewer views.
 *
 * `multiplier` (added 2026-08-14) — when a property_booking_overrides
 * row supplies a bespoke rewards_multiplier (e.g. 2× for Saratoga
 * Casino Hotel via the CJ deep link), pass it here to replace the
 * default "1X" and drop the "3X advisor" tail (bespoke multipliers
 * are static, they don't have an advisor upgrade path).  A value of
 * exactly `1` renders the default "Earn 1X" line unchanged.
 *
 * `tone`:
 *   "light"  → for cream/white card backgrounds (Explore, Bookmarks,
 *              Stay Search) — muted navy text.
 *   "atlas"  → for the Atlas Smart Compare filtered view — matches the
 *              Atlas navy-on-cream palette used by that surface.
 */
import React from "react";
import { Link } from "react-router-dom";

export default function EarnPointsCta({ tone = "light", multiplier = 1 }) {
  const base = tone === "atlas"
    ? "text-tb-navy/55 border-tb-navy/15"
    : "text-tb-navy/60 border-tb-cream-3";
  const m = Math.max(1, parseInt(multiplier, 10) || 1);
  if (m > 1) {
    return (
      <div
        data-testid="earn-points-cta"
        data-multiplier={m}
        className={`mt-2 pt-2 border-t font-hand text-[11px] leading-snug ${base}`}
      >
        <span
          data-testid="earn-points-cta-multiplier"
          className="font-semibold text-tb-navy/85"
        >
          Earn {m}X TravelBio Points
        </span>
      </div>
    );
  }
  return (
    <div
      data-testid="earn-points-cta"
      data-multiplier={1}
      className={`mt-2 pt-2 border-t font-hand text-[11px] leading-snug ${base}`}
    >
      <span data-testid="earn-points-cta-base">Earn 1X TravelBio Points</span>
      <span className="mx-1 opacity-60">·</span>
      <span>Earn 3X with a{" "}
        <Link
          to="/advisors"
          data-testid="earn-points-cta-advisor-link"
          className="underline decoration-tb-navy/40 hover:decoration-tb-navy transition text-tb-navy/80"
        >
          travel advisor
        </Link>{" "}
        →
      </span>
    </div>
  );
}
